module.exports = __webpack_public_path__ + "static/media/mall-discount.331df303.svg";